// Adapted from https://www.npmjs.com/package/vue-jwt-decode
function decodeJwt(jwt) {
  try {
    if (typeof jwt !== 'string') return null;

    const splitted = jwt.split('.');
    if (splitted.length < 2) return null;

    const obj1 = JSON.parse(atob(splitted[0]));
    const obj2 = JSON.parse(atob(splitted[1]));

    return { ...obj1, ...obj2 };
  } catch (err) {
    return {};
  }
}

export default decodeJwt;
